import { render } from "./theme2.vue?vue&type=template&id=8c8d6eae&scoped=true"
import script from "./theme2.vue?vue&type=script&lang=js"
export * from "./theme2.vue?vue&type=script&lang=js"

import "./theme2.vue?vue&type=style&index=0&id=8c8d6eae&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8c8d6eae"

export default script